export default {
    "/": {
        "title": "Taoify - 글로벌 전자상거래 플랫폼 | 중국 제품, 세계로",
        "desc": "Taoify는 웹사이트 구축, 번역, 상품 등록, 물류, 결제, 마케팅을 하나의 백오피스로 통합: 18명의 AI 직원이 도와드리며, 20개 언어로 매장을 열고 중국 제품을 전 세계에 판매합니다."
    },
    "/feature": {
        "title": "기능 · 매장 운영에 필요한 모든 것, 한 페이지에 · Taoify",
        "desc": "웹사이트 구축, 번역, 상품 등록, 배송, 결제, 고객 유치 - Taoify는 크로스보더 판매에 필요한 15가지 모듈을 하나의 백오피스로 통합하여 여러 도구를 따로 사용할 필요가 없습니다."
    },
    "/ai-staff": {
        "title": "AI 직원 · 18명의 AI 직원, 트래픽 유입 담당자가 가장 바쁨 · Taoify",
        "desc": "18명의 AI 직원 중 성장 그룹의 5명은 '방문자 부족' 문제를 해결: 12가지 매장 진단, 30일 마케팅 계획, 하나의 상품을 9개 채널용으로 재작성, 자동 마케팅 이메일로 기존 고객 재유치."
    },
    "/logistics": {
        "title": "크로스보더 물류 · 당신의 손에서 고객의 손까지 · Taoify",
        "desc": "수출, 통관, 주요 노선, 최종 배송, 세 가지 경로를 상품과 시간에 따라 선택. YunExpress, Yanwen, 4PX와 연결, 운송 라벨, 추적, 예외 처리 모두 하나의 백오피스에서 관리 가능."
    },
    "/payment": {
        "title": "결제 및 정산 · 고객이 편한 방법으로 결제 · Taoify",
        "desc": "PayPal, Stripe, 신용카드, Alipay 즉시 사용 가능. 외화 수령, 위안화 인출, T+7 일 결산, 수수료율과 입금 시간 명확히 표시."
    },
    "/pricing": {
        "title": "가격 · 구독 패키지 + 단계별 수수료 · Taoify",
        "desc": "매장은 구독 패키지로 요금 청구: 기본 $15/월, 표준 $29/월, 프리미엄 $59/월, 분기 또는 연간 결제 시 더 저렴. 거래 수수료는 월 거래액에 따라 단계적으로 적용, 최저 3%."
    },
    "/cases": {
        "title": "판매자 사례 · 그들도 같은 일을 하고 있습니다 · Taoify",
        "desc": "의우 주얼리, 선전 3C, 광저우 의류, 그리고 독일, 미국, 프랑스의 판매자들 - 여섯 명의 사람들, 여섯 가지 출발점, 동일한 방법."
    },
    "/sign-up": {
        "title": "가게 개설 - Taoify 무료 가입 및 매장 개설",
        "desc": "10분 만에 브랜드 독립 사이트 구축, 제로 코드, 모든 기능을 포함한 구독 패키지 체험, 전체적인 클로즈드 루프. 지금 Taoify에 가입하여 크로스보더 전자상거래 여행을 시작하세요."
    },
    "/for-china-sellers": {
        "title": "중국 판매자를 위한 · 상품 선택과 가격 설정만 신경 쓰세요, 나머지는 우리가 처리합니다 · Taoify",
        "desc": "사이트 구축, 번역, 운송비, 배송 라벨 인쇄, 고객 응대 - 크로스보더 판매 중간의 이러한 번거로운 일들은 플랫폼이 대신 해드립니다. 구독 패키지 + 단계별 수수료 (최저 3%)."
    },
    "/for-global-sellers": {
        "title": "해외 판매자를 위한: 중국의 진열대에서 상품을 선택하고, 당신의 가게에서 판매하세요 · Taoify",
        "desc": "재고를 보유하지 않고, 창고를 운영하지 않아도 됩니다: 중국 공급망에서 상품을 선택하여 판매하고, 고객이 주문하면 중국 창고에서 직접 발송하여 차익을 얻으세요. BuyLink은 1688, 타오바오 링크를 당신의 상품으로 변환할 수도 있습니다."
    },
    "/template-index": {
        "title": "템플릿 마켓 - Taoify 전문 웹사이트 테마 템플릿",
        "desc": "어떤 프로젝트에도 적합한 전문 테마 웹사이트 템플릿, 다양한 업계 템플릿을 무료로 사용 가능, 필요에 따라 브랜드 이미지와 기능을 맞춤 설정하세요."
    },
    "/question": {
        "title": "도움말 센터 · 문제가 있으면 먼저 여기서 찾아보세요 · Taoify",
        "desc": "가게 개설, 디자인, 상품 등록, 주문 및 물류, 결제, 마케팅, 계정 권한 - 카테고리별로 정리된 자주 묻는 질문, 찾지 못했다면 지원 티켓을 생성하세요."
    },
    "/about-us": {
        "title": "Taoify에 대해 · 우리는 무엇을 하고 있는가",
        "desc": "Taoify는 크로스보더 판매자를 위한 통합 플랫폼입니다: 웹사이트 구축, 번역, 상품 등록, 물류, 결제, 마케팅을 하나의 관리자 페이지에서 모두 처리할 수 있습니다."
    },
    "/privacy-policy": {
        "title": "개인정보 보호정책 · Taoify",
        "desc": "Taoify이 어떻게 귀하의 개인 정보를 수집, 사용, 저장, 보호하는지, 그리고 귀하가 자신의 데이터에 어떤 권리를 가지는지에 대한 내용입니다."
    },
    "/terms-service": {
        "title": "서비스 약관 · Taoify",
        "desc": "Taoify 플랫폼 서비스 이용 시 계정, 가게, 주문, 결제 및 책임 분담에 관한 약관과 조건입니다."
    },
    "/consumer-agreement": {
        "title": "환불 정책 · Taoify",
        "desc": "Taoify 플랫폼 주문의 환불 및 사후 서비스 규칙: 신청 조건, 처리 시간 및 입금 방법."
    },
    "/user-agreement": {
        "title": "이용 약관 · Taoify",
        "desc": "Taoify를 등록하고 사용하기 전에 반드시 확인하세요: 계정 등록, 가게 운영 규정 및 플랫폼 서비스 안내입니다."
    }
}
